import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { setFeedOrder } from "web/redux/ducks/feed-filters";
import { ReduxStoreState } from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./feed-sort.css";

const AnalyticsActions = {
    newest: "SORT_BY_NEWEST",
    price_desc: "SORT_BY_HIGH_LOW",
    price_asc: "SORT_BY_LOW_HIGH",
    recommended: "SORT_BY_RECOMMENDED",
    best_sellers: "SORT_BY_BEST_SELLERS",
};

interface SortOption {
    label: string;
    value: string;
    selected: boolean;
}

export interface FeedSortProps {
    sortOptions: SortOption[];
}

export function FeedSort({ sortOptions }: FeedSortProps): JSX.Element {
    const sort = useSelector((state: ReduxStoreState) => state.feedFiltersReducer.active.view);
    const dispatch = useDispatch();

    const selected = useMemo(() => {
        for (let option of sortOptions) {
            if (typeof sort === "undefined" && option.selected) {
                return option;
            } else if (option.value === sort) {
                return option;
            }
        }
        // Fallback for when bad things happen
        return sortOptions[0];
    }, [sort, sortOptions]);

    function onChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        const sort = event.target.value;
        analytics.event("sort_by", AnalyticsActions[sort]);
        dispatch(setFeedOrder(sort));
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.select}>
                <select
                    aria-label={gettext("feed.sort.mobile_btn_text")}
                    value={selected.value}
                    onChange={onChange}
                >
                    {sortOptions.map(({ value, label }) => (
                        <option key={value} value={value}>
                            {label}
                        </option>
                    ))}
                </select>
            </div>
            <button
                type="button"
                className={styles.mobile}
                aria-label={gettext("feed.sort.mobile_btn_text")}
            >
                <SVGIcon name="sort" />
            </button>
        </div>
    );
}
